/* @import '../../global/min-app.css'; */

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
}

#search-dropdown,
#mobile-search-dropdown {
  @apply !rounded-[8px] sm:!rounded-[12px];
  border: 1px solid var(--ui-gray-4);
  box-shadow: none !important;
}

.search-container.light .search-page-bar,
.search-container.light .search-box,
.search-container.light .search-page-clear,
.search-container.light .search-page-submit {
  @apply bg-white text-ui-gray-3 transition-colors !important;
}

.search-container.light .search-icon {
  background-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/search-icon-blue.svg') !important;
}

.search-container.light .search-page-clear {
  @apply hover:text-dark-blue !important;
}

.search-container.light .search-page-bar {
  @apply border-medium-blue text-ui-gray-1 placeholder:text-ui-gray-3 !important;
}

.search-box {
  @apply bg-dark-blue py-40px rounded-xl px-40px w-full mx-auto;
}

.search-page-bar-wrapper {
  @apply w-full max-w-[900px] mx-auto relative;
}

.search-page-bar {
  @apply w-full bg-dark-blue !text-white text-0 md:text-1 placeholder:text-white appearance-none font-poppins !border-t-0 !border-l-0 !border-r-0 border-b !rounded-none focus:outline-none;
}

.search-page-submit {
  @apply bg-dark-blue text-white border-none;
}


.search-icon {
  @apply absolute w-24px h-24px bottom-0 right-2px  fill-white;
  background-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/search-icon-white.svg') !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}


.search-page-clear {
  @apply appearance-none  px-4px bg-dark-blue text-white border-none cursor-pointer my-12px !font-poppins;
}

@media(max-width: 999px) {
  .search-page-clear {
    @apply !block;
  }
}